export default __webpack_public_path__ + "static/media/typeBoat.6044e91f.svg";